/********************* Libraries ***********************/
import React, { useRef } from "react";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

/********************* Constants & Utils ***********************/
import { client } from "helpers/client";
import { useAuthContext } from "store/auth";
import { PreregisterDto, usePreregisterData } from "pages/registration/registration.service";

/********************* Components Core ***********************/
import { Button, CheckBoxField, Form, InputField } from "components/form";
import { EmailPattern } from "helpers/patterns";
import qs from "qs";

const LoginPage = () => {
  const formRef = useRef();
  const [{ isLoggedIn }, userDispatch] = useAuthContext();
  const { setPreregisterData } = usePreregisterData();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const returnUrl = qs.parse(location.search, { ignoreQueryPrefix: true })["return-url"];

  const { mutate, isLoading } = useMutation((data) => client<{ token: string; refreshToken: string }>("/auth/login", { data }));

  function handleLogin(data: any) {
    setPreregisterData(undefined);
    mutate(data, {
      onSuccess({ response, error }) {
        if (error) return (formRef.current as any).reset();
        userDispatch({
          type: "login",
          token: response!.token,
          refresh: response!.refreshToken,
          staySignedIn: data.signed_in
        });
        navigate((returnUrl as string) ?? "/");
      }
    });
  }

  if (isLoggedIn) return <Navigate to="/" replace />;
  return (
    <div className="login">
      <div className="row">
        <div className="col-xl-8 col-lg-10 mx-auto">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="title">
                {t("login:login") as string}
                <span>{t("login:in") as string}</span>
              </h1>
            </div>
            <Form
              formRef={formRef}
              className="col-lg-6"
              onSubmit={handleLogin}
              defaultValues={{
                email: "",
                password: ""
              }}
            >
              <InputField
                id="email"
                label={t("login:username")}
                rules={{ required: "errors:required", pattern: { value: EmailPattern, message: "errors:invalidFormat" } }}
              />
              <InputField id="password" type="password" label={t("login:password")} rules={{ required: "errors:required" }} />
              <div className="box-password">
                <CheckBoxField id="signed_in" label={t("login:staysigned")} />
                <Link
                  to="/forget-password"
                  className="forgot"
                  onClick={() => {
                    setPreregisterData(undefined);
                  }}
                >
                  {t("login:forgot") as string}
                </Link>
              </div>
              <Button type="submit" isLoading={isLoading} className="btn-blue">
                {t("home:login") as string}
              </Button>
              <div className="box-signup">
                <span>
                  {t("login:donthave") as string}
                  <Link
                    to="/temp-register"
                    onClick={() => {
                      setPreregisterData(undefined);
                    }}
                  >
                    {t("login:signup")}
                  </Link>
                </span>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
